import React, { useEffect, useState } from "react";
import withLayout from "@Src/layouts/withLayout";
import { useQuery } from "react-query";
import { fetchBuyCarMenuList, getRace } from "@Services/buyCarMenu";
import { EBaseMenuType } from "@Types/constants";
import { fetchRaceApi } from "../../services/ApiKey";
import RollingBarrage from "@Components/buyCarMenu/RollingBarrage";
import { transFormRaceData } from "./service";
import FilterCondition from "@Components/buyCarMenu/FilterCondition";
import { useSetState, useUpdateEffect } from "ahooks";
import qs from "qs";
import AmountMenu from "@Components/buyCarMenu/AmountMenu";
import MenuList from "@Components/buyCarMenu/MenuList";
import { IBuyCarMenuList } from "@Types/buyCarMenu";
import { Pagination, PaginationProps, Spin } from "antd";
import { ArrowLeftIcon, ArrowRightIcon } from "@t8891/icon";
import styled, { createGlobalStyle } from "styled-components";
import RightList from "@Components/buyCarMenu/right";
import { setUrlFormat } from "@Lib/common";
import { LoadingOutlined } from "@ant-design/icons";
import { fetchLike, fetchLikeStatusBulk } from "@Services/article";

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const GlobalStyles = createGlobalStyle`
  body {
    font-family: 微軟正黑體 !important;
  }
`;

const PagingContent = styled.div`
  .ant-pagination-item {
    border-radius: 5px !important;
  }
  .ant-pagination-item-active {
    background: #3264ff !important;
    border: unset;
    a {
      color: #fff !important;
    }
  }
  .ant-pagination-item:hover {
    border-radius: 5px !important;
    background: #3264ff !important;
    border: unset;
    a {
      color: #fff !important;
    }
  }
`;

// 自定义过滤器函数，排除空值
const filter = (key, value) => {
  if (
    value === "" ||
    value === null ||
    value === undefined ||
    key.includes("Name") ||
    key === "brandId" ||
    key === "kindId"
  ) {
    return;
  }
  return value;
};
const LIMIT = 30;
function removeEmptyValues(obj: any) {
  // 使用 Object.entries 获取对象的键值对数组
  return (
    Object.entries(obj)
      // 过滤掉值为空的键值对
      .filter(
        ([key, value]) =>
          value !== null &&
          value !== undefined &&
          value !== "" &&
          key !== "orders" &&
          (Array.isArray(value) ? value.length > 0 : true),
      )
      // 使用 reduce 构建一个新的对象
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {})
  );
}

export const initCondition = {
  brandId: "",
  brandIdName: "",
  kindId: "",
  kindIdName: "",
  autoType: "",
  autoTypeName: "",
  price: "",
  priceName: "",
  regionId: "",
  regionIdName: "",
  color: "",
  colorName: "",
  insurance: "",
  page: 1,
  limit: LIMIT,
  insuranceName: "",
  type: [],
  paymentType: "",
  paymentTypeName: "",
  orders: [],
  sort: "",
};

let offSwitchPush = false;
function onChange({ items, keys, brandItems, params, setParams, orders }) {
  // 筛选条件反选
  if (params[keys.value] === `${items.value}`) {
    const needRemoveField = [`${items.field}`];
    if (String(items.field) === "brandId") {
      needRemoveField.push("kindId");
    }
    const filterOrders =
      orders?.filter((item) => {
        if (needRemoveField.includes(item.field)) return false;
        return true;
      }) || [];

    const updateParams = {
      [keys.value]: "",
      [keys.name]: "",
      orders: [...filterOrders],
      query: {},
      page: params.page || 1,
      limit: params?.limit || LIMIT,
    };
    if (String(items.field) === "brandId") {
      updateParams["kindId"] = "";
      updateParams.query = { kindId: "", kindName: "" };
    }
    setParams(updateParams);
    return;
  }
  let filterOrders = orders.filter((item) => item.field !== items.field);
  let query = {};

  if (items.field === "brandId") {
    query = {
      kindId: "",
      kindIdName: "",
    };
    filterOrders = filterOrders.filter((item) => item.field !== "kindId");
  }

  if (items.field === "kindId") {
    let isBrand = orders.some((item) => item.field === "brandId");

    if (!isBrand) {
      filterOrders = [brandItems, ...filterOrders];
    }
    query = {
      brandId: `${brandItems.value}`,
      brandIdName: brandItems.name,
    };

    setParams({
      [keys.value]: `${items.value}`,
      orders: [...filterOrders, items],
      [keys.name]: items.enName || items.name,
      ...query,
      page: 1,
      limit: LIMIT,
    });
    return;
  }

  setParams({
    [keys.value]: `${items.value}`,
    [keys.name]: items.enName || items.name,
    orders: [items, ...filterOrders],
    // 点赞排序的筛选只请求一次
    sort: params.sort === "like" ? "postDate-desc" : params.sort,
    ...query,
    page: 1,
    limit: LIMIT,
  });
}

const initData: IBuyCarMenuList = {
  brand: {},
  kind: {},
  list: [],
  menuCount: {
    seek: 0,
    share: 0,
  },
  paging: "",
  total: -1,
};
let cTimeOut: any;

const itemRender: PaginationProps["itemRender"] = (_, type, originalElement) => {
  if (type === "prev") {
    return (
      <div
        className='bg-white h-32 justify-center flex items-center rounded-4 pr-10 pl-4 text-14'
        style={{ border: "1px solid #E8E8E8" }}
      >
        <ArrowLeftIcon size={32} fill='#333' strokeWidth={4} />
        上一頁
      </div>
    );
  }
  if (type === "next") {
    return (
      <div
        className='bg-white h-32 justify-center flex items-center rounded-4 pl-10 pr-4 text-14'
        style={{ border: "1px solid #E8E8E8" }}
      >
        下一頁
        <ArrowRightIcon size={32} fill='#333' strokeWidth={4} />
      </div>
    );
  }
  return originalElement;
};

const BuyCarMenuList = () => {
  const [isLoading, setLoading] = useState<boolean>(true);

  const [params, setParams] = useSetState<any>(initCondition);
  const [likeList, setLikeList] = useState<Record<number, any>>({});

  // 首次进来是否有操作过筛选
  const [isFirstRecommend, setIsFirstRecommend] = useState(1);

  const [query, setQuery] = useSetState<any>({
    brandName: 0,
    kindName: 0,
  });

  const { orders, sort, page } = params;

  //   /** 获取跑马灯数据 */
  const { data: raceData } = useQuery(fetchRaceApi.toString(), async () => {
    const res = await getRace({ type: EBaseMenuType.BUY_CAR_MENU });
    if (res.status === 12000 && res.data) {
      return res.data?.list;
    }
    return [];
  });

  const fetchLikeStatus = async (ids: string) => {
    const res = await fetchLikeStatusBulk({ model: "buycarMenu", ids });
    if (res.status === 12000) {
      res.data?.like?.forEach?.((item: number) => {
        likeList[item] = item;
      });
      setLikeList({ ...likeList });
    }
  };

  const clickLikeItem = async (id: number) => {
    const res = await fetchLike({
      id: id,
      model: "buycarMenu",
      action: "like",
    });
    if (res.status === 12000) {
      likeList[id] = id;
      setLikeList({ ...likeList });
      return true;
    }
    return false;
  };

  const getRecommendation = (orders, hasBrandAndKind, filteredData) => {
    // 1：没有任何参数的情况。
    // 3：廠牌車款 + 其他篩選條件參數。
    // 7：有且只有廠牌厂牌车款
    if (orders.length === 2 && hasBrandAndKind) {
      return 7;
    }
    if (filteredData.length > 0) {
      return 3;
    }
    return 1;
  };

  const { data = initData, refetch } = useQuery<IBuyCarMenuList>(
    [`fetchBuyCarMenuList`],
    async () => {
      const currentParams = { ...params, insuranceType: params.insurance || "" };
      const hasBrandAndKind = !!params.brandId && !!params.kindId;
      const filteredData = orders.filter((item) => item.field !== "brandId" && item.field !== "kindId");
      delete currentParams.insurance;

      const res = await fetchBuyCarMenuList({
        ...removeEmptyValues(currentParams),
        recommend: getRecommendation(orders, hasBrandAndKind, filteredData),
        mustRecommend: isFirstRecommend,
      });
      if (res?.status === 12000) {
        setLoading(false);
        setQuery({
          brandName: res.data.brand?.brandName || "",
          kindName: res.data.kind?.kindName || "",
        });
        fetchLikeStatus(res.data?.list?.map((i: { id: number }) => i.id)?.join(","));
        return res.data;
      }
      return initData;
    },
    {
      enabled: !!sort,
    },
  );

  const { list, total } = data;

  useEffect(() => {
    let paramsUrl = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (!!paramsUrl.page || !!paramsUrl.limit) {
      setParams({ page: paramsUrl.page || 1, limit: paramsUrl.limit || LIMIT });
    }
  }, []);

  useUpdateEffect(() => {
    clearTimeout(cTimeOut);
    setLoading(true);
    // 更新api
    cTimeOut = setTimeout(() => {
      refetch();
    }, 150);
  }, [params]);

  useUpdateEffect(() => {
    const qsStr = qs.stringify({ ...params, orders: [] }, { filter });

    let baseUrl = `${location.origin}/menu`;

    if (!!query.brandName && !query.kindName) {
      baseUrl = `${baseUrl}/${setUrlFormat(query.brandName)}`;
    }
    if (!!query.kindName) {
      baseUrl = `${baseUrl}/${setUrlFormat(query.brandName)}/${setUrlFormat(query.kindName)}`;
    }

    // 将查询字符串附加到 URL
    const newUrl = `${baseUrl}${qsStr === "" ? qsStr : `?${qsStr}`}`;

    // 使用 history.replaceState 更新 URL
    if (offSwitchPush) {
      history.replaceState(null, "", newUrl);
    } else {
      offSwitchPush = true;
    }
  }, [query]);

  return (
    <>
      <GlobalStyles />
      <div className='w-full  bg-[#F9F9F9] py-20' style={{ minHeight: "100svh" }}>
        <div className='w-1190 mx-auto flex flex-col'>
          {/* 跑马灯 */}
          <RollingBarrage
            containerStyle={{ marginBottom: "20px", width: "100%" }}
            data={transFormRaceData(raceData || [])}
          />

          <img className='w-1190 h-70 mb-20' src='https://photo.8891.com.tw/2024/08/30/1725002128799972.png' />
        </div>
        <div className='w-1190 mx-auto flex gap-20'>
          <div className='w-930'>
            {/* 筛选条件 */}
            <FilterCondition
              params={params}
              setParams={setParams}
              onClear={() => {
                setIsFirstRecommend(1);
              }}
              onChange={(items, keys, brandItems) => {
                setIsFirstRecommend(1);
                onChange({ items, keys, brandItems, params, setParams, orders });
              }}
            />

            {/* 共找到多少菜单 分享征求时间价格 */}
            {total !== -1 && (
              <>
                <AmountMenu
                  total={total}
                  params={params}
                  onClick={(props) => {
                    if (props.sort) {
                      setIsFirstRecommend(0);
                    } else {
                      setIsFirstRecommend(1);
                    }
                    setParams({ ...props, page: 1, limit: LIMIT });
                  }}
                />

                {/* 菜单列表 */}
                <Spin indicator={antIcon} spinning={isLoading} tip='加載中...'>
                  <>
                    {total === 0 && !!list.length && (
                      <div className='w-930 pt-12 pb-30 flex items-center justify-center text-16 text-[#333]'>
                        <i className='w-30 h-1 bg-[#BBBBBB] mr-14' />
                        暫無相關菜單，為您推薦以下車款
                        <i className='w-30 h-1 bg-[#BBBBBB] ml-14' />
                      </div>
                    )}
                    {total === 0 && !list.length && (
                      <div className='w-930 h-400 flex items-center justify-center text-16 text-black text-center flex-col'>
                        <img className='w-68 h-52' src='https://photo.8891.com.tw/2024/08/30/1725002455459910.png' />
                        <div className='text-center mt-10 text-[#666]'>目前暫無符合的菜單內容</div>
                        <div
                          className='w-[115px] h-30 text-white flex items-center justify-center text-14 bg-[#3264FF] rounded-16 mt-12 cursor-pointer'
                          onClick={() => {
                            setParams({ ...initCondition, sort: "postDate-desc" });
                          }}
                        >
                          查看其他菜單
                        </div>
                      </div>
                    )}
                    <MenuList params={params} data={list} likeList={likeList} clickLikeItem={clickLikeItem} />
                  </>
                </Spin>

                {/* 分页 */}
                {total !== 0 && (
                  <div className='w-930'>
                    <PagingContent>
                      <Pagination
                        showSizeChanger={false}
                        className='flex justify-center'
                        pageSize={30}
                        onChange={(page) => {
                          setParams({ page });
                          window.scrollTo(0, 180);
                        }}
                        current={Number(page)}
                        total={total}
                        itemRender={itemRender}
                      />
                    </PagingContent>
                  </div>
                )}
              </>
            )}
          </div>
          {/* 右侧栏目列表 */}
          {total !== -1 && <RightList />}
        </div>
      </div>
    </>
  );
};

withLayout({
  cmp: <BuyCarMenuList />,
  params: {
    AdTopBanner: true,
    nav: "DefaultFixedNav",
    footer: "Footer",
  },
});
